// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"eabd50de14be1cb7e98f","452":"dd1f41e0d6e7ec1e5603","453":"481478e69e07b963bdb9","896":"3578839a6c4acf826609"}[chunkId] + ".js";
};